import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		padding: THEME.spacing.lg,
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	heading: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: THEME.typography.fontSizes.xl,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: 0,
	},
	message: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	repPicker: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
	},
});
